export default __webpack_public_path__ + "static/home-two-newsletter-bg-b9654bbab0fda404c8bfb035be7a3421.jpg";